import { render } from "./CommentItem.vue?vue&type=template&id=a9cfc6fe&ts=true"
import script from "./CommentItem.vue?vue&type=script&lang=ts"
export * from "./CommentItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__